export default "__VITE_ASSET__8257158d__"